import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SidebarModule } from '@coreui/angular-pro';
import { AuthService } from '../../../../services/auth/service/auth.service';
import { FetchUserService } from '../../../../services/fetchServices/fetchUser/fetch-user.service';
import { ThemeService } from '../../../../services/shared/theme.service';
import { Router } from '@angular/router';
import { SvgIconService } from '../../../../services/shared/icons/svg-icon.service';
import { ScreenService } from '../../../../services/shared/screen.service';

@Component({
  selector: 'app-menu-sidebar',
  imports: [CommonModule, SidebarModule],
  templateUrl: './menu-sidebar.component.html',
  styleUrl: './menu-sidebar.component.scss',
})
export class MenuSidebarComponent {
  @Input() isVisible = true;
  @Output() closeSidebar = new EventEmitter<void>();
  dropDownNav1: boolean = true;
  dropDownNav2: boolean = true;
  userIconUrl: any;
  userName: string = 'Benutzername';
  userEmail: string = '';

  constructor(
    private authService: AuthService,
    private fetchUserService: FetchUserService,
    public themeService: ThemeService,
    private router: Router,
    public svgIconService: SvgIconService,
    public screenService: ScreenService,
  ) {}

  navOpt = [
    {
      name: 'Planung',
      website: false,
      url: '',
      title: true,
      permissions: [],
      roles: ['Buero', 'Admin', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
    {
      name: 'Kalender',
      website: false,
      url: 'admin-calendar',
      icon: 'kalender',
      roles: ['Buero', 'Admin', 'Personal', 'Teamleitung', 'Ausbildung'],
    },
    {
      name: 'Blocker',
      website: false,
      url: 'blocker-calendar',
      icon: 'blockersonstiges',
      roles: ['Admin'],
    },

    {
      name: 'Aufträge',
      website: false,
      url: '',
      title: true,
      permissions: [],
      roles: ['Buero', 'Admin', 'Personal'],
    },
    {
      name: 'Kunden',
      website: false,
      url: 'customer-table',
      icon: 'kunden',
      permissions: [],
      roles: ['Buero', 'Admin', 'Personal'],
    },
    {
      name: 'Abrechnung',
      website: false,
      url: '',
      title: true,
      permissions: [],
      roles: ['Buero', 'Admin', 'Personal'],
    },
    {
      name: 'Terminsortierung',
      website: false,
      url: 'termin-sortierung',
      icon: 'sortieren',
      permissions: [],
      roles: ['Buero', 'Admin', 'Personal'],
    },
    {
      name: 'Dolmetscher',
      website: false,
      url: '',
      title: true,
      permissions: [],
      roles: ['Dolmetscher', 'Admin', 'Teamleitung', 'Ausbildung'],
    },
    {
      name: 'Dolmetscher Kalender',
      website: false,
      url: 'interpreter-calendar',
      icon: 'kalender',
      permissions: [],
      roles: ['Dolmetscher', 'Admin', 'Teamleitung', 'Ausbildung'],
    },
    {
      name: 'Benutzer',
      website: false,
      url: '',
      title: true,
      permissions: [],
      roles: [],
    },
    {
      name: 'Intranet',
      website: true,
      url: 'intranet',
      icon: 'intranet',
      permissions: [],
      roles: [],
    },
    {
      name: 'Aufgaben-App',
      website: true,
      url: 'aufgaben',
      icon: 'aufgaben',
      permissions: [],
      roles: [],
    },
    {
      name: 'Bestätigungs-App',
      website: true,
      url: 'bestaetigung',
      icon: 'bestaetigung',
      permissions: [],
      roles: [],
    },
    {
      name: 'Admin-Management-App',
      website: true,
      url: 'adminManagement',
      icon: 'admin',
      permissions: [],
      roles: ['Admin'],
    },
    {
      name: 'Einstellungen',
      website: false,
      url: 'Einstellungen',
      icon: 'einstellungen',
      permissions: [],
      roles: [],
    },
  ];

  navItems: any = [];

  ngOnInit() {
    this.getUserName();
    this.getUserEmail();
    this.getUserPermission();
    this.getUserRole();
    this.loadUserIcon();
    this.navItems = this.filterNav(this.navOpt);
  }

  isActive(url: string): boolean {
    return this.router.url.includes(url);
  }

  getUserRole(): string | null {
    const authUserString = localStorage.getItem('authUser');

    if (!authUserString) {
      return null;
    }

    try {
      const authUser = JSON.parse(authUserString);

      return authUser.user?.role || authUser.role || null;
    } catch (error) {
      console.error('Fehler beim Parsen:', error);
      return null;
    }
  }

  ngAfterViewInit() {
    this.bindNavClicks();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisible']) {
      setTimeout(() => {
        this.bindNavClicks();
        const links = document.querySelectorAll('.sidebar-nav a');

        links.forEach((link) => {
          link.setAttribute('target', '_blank');
        });
      });
    }
  }

  bindNavClicks() {
    const links = document.querySelectorAll('.sidebar-nav a');

    links.forEach((link) => {
      const href = link.getAttribute('href');

      if (href && !href.startsWith('http')) {
        link.removeAttribute('target');
      }

      link.addEventListener('click', () => {
        this.close();
      });
    });
  }

  filterNav(items: any) {
    const userPermissions = this.getUserPermission();
    const userRole = this.getUserRole();

    return items
      .filter((item: { roles: string | string[]; permissions: any[] }) => {
        const hasRoleAccess =
          !item.roles ||
          item.roles.length === 0 ||
          item.roles.includes(userRole || '');

        const hasPermissionAccess =
          !item.permissions ||
          item.permissions.length === 0 ||
          item.permissions.some((p) => userPermissions.includes(p));

        return hasRoleAccess && hasPermissionAccess;
      })
      .map((item: { children: any }) => ({
        ...item,
        children: item.children ? this.filterNav(item.children) : undefined,
      }));
  }

  getUserName() {
    const firstname = localStorage.getItem('firstName');
    const lastname = localStorage.getItem('lastName');
    this.userName = firstname + ' ' + lastname;
  }

  getUserEmail() {
    const userJson = localStorage.getItem('authUser');

    if (userJson) {
      const authData = JSON.parse(userJson);

      if (authData.user && authData.user.email) {
        this.userEmail = authData.user.email;
      }
    }
  }

  loadUserIcon() {
    this.userIconUrl = './../../../../assets/icons/user.png';

    this.fetchUserService.loadUserIcon().subscribe(
      (blob: Blob | null) => {
        if (blob && blob.size > 0) {
          this.userIconUrl = URL.createObjectURL(blob);
          console.log('Benutzerbild erfolgreich geladen:', this.userIconUrl);
        } else {
          console.warn('Kein gültiges Benutzerbild vorhanden.');
          this.userIconUrl = './../../../../assets/img/app-icons/user.png';
        }
      },
      (error: any) => {
        console.error('Fehler beim Laden des Benutzerbildes:', error);
        this.userIconUrl = './../../../../assets/img/app-icons/user.png';
      },
    );
  }

  close() {
    this.closeSidebar.emit();
  }

  reloadPage() {
    location.reload();
  }

  scrollToElement(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.close();
    }
  }

  logout() {
    this.authService.logout();
  }

  toggleDropdown<K extends keyof this>(key: K) {
    if (typeof this[key] === 'boolean') {
      this[key] = !this[key] as this[K];
    }
  }

  getUserPermission(): string[] {
    const authUserString = localStorage.getItem('authUser');

    if (!authUserString) {
      return [];
    }

    try {
      const authUser = JSON.parse(authUserString);

      const rawPermissions =
        authUser.user?.permissions || authUser.permissions || [];

      const permissions =
        typeof rawPermissions === 'string'
          ? JSON.parse(rawPermissions)
          : rawPermissions;

      // Alle permission_level sammeln
      return permissions.map((p: any) => p.permission_level);
    } catch (error) {
      console.error('Fehler beim Parsen:', error);
      return [];
    }
  }

  navigateTo(route: string) {
    if (!route) return;
    window.location.href = route;
    //localStorage.removeItem('selectedTeamId');
  }

  openWebsite(path: string) {
    if (path === 'intranet') {
      window.open('https://intranet.tridimo.de/dashboard', '_blank');
    } else if (path == 'bestaetigung') {
      window.open('https://bestaetigung.tridimo.de', '_blank');
    } else if (path == 'aufgaben') {
      window.open('https://aufgaben.tridimo.de/todo', '_blank');
    } else if (path == 'adminManagement') {
      window.open('https://admin-management.tridimo.de/dashboard', '_blank');
    }
  }
}
